module.exports = __webpack_public_path__ + "img/colored-arrow.16ecc93b.svg";